export default function removeNullProps(obj) {
  if (typeof obj !== 'object' || obj === null || Array.isArray(obj))
    throw new Error('removeNullProps can only be used with objects');

  const entries = Object.entries(obj);

  return entries.reduce((acc, [key, value]) => {
    if (Object.prototype.hasOwnProperty.call(obj, key) && value !== null && value !== undefined)
      acc[key] = value;
    return acc;
  }, {});
}
